import * as Yup from "yup";

export const userValidation = Yup.object().shape({
  mobile: Yup.string()
    .required("وارد کردن موبایل الزامی است")
    .min(11, "موبایل باید 11 رقمی باشد!")
    .max(11, "موبایل باید 11 رقمی باشد!"),
  password: Yup.string()
    .min(5, "رمز عبور خیلی کوتاه است!")
    .max(48, "رمز عبور خیلی بلند است!"),
  name: Yup.string()
    .required("وارد کردن نام الزامی است")
    .min(3, "نام باید حد اقل 3 حرفی باشد.!"),
  address: Yup.string().min(10, "آدرس حد اقل باید 10 حرف داشته باشد."),
});
